import { render, staticRenderFns } from "./FailableEcText.vue?vue&type=template&id=63afbe65&scoped=true&"
import script from "./FailableEcText.vue?vue&type=script&lang=js&"
export * from "./FailableEcText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63afbe65",
  null
  
)

export default component.exports